import React, { useRef } from 'react';
import { translate } from '../../Services/translation';
import * as csvParser from 'csv-parse';
import { post } from '../../Services/http';
import Notification from '../Notification';

const QuickOrderHeader = (props) => {
  const {
    defaultNumRows,
    setRows,
    getEmptyRow,
    formatPrice,
    getCalculatedTotalPrice,
    addRowToEnd,
    addNotification,
    notification,
  } = props;
  const importFileInputRef = useRef();

  const importCSV = () => {
    // Open file input dialog when clicking the "import" button
    importFileInputRef.current.click();
  };

  const parseCSV = (files) => {
    if (!files || files.length == 0) return;
    var file = files[0];

    // Read the file content
    var reader = new FileReader();
    reader.readAsText(file, 'UTF-8');

    reader.onload = (e) => {
      // On file has been read
      var fileText = reader.result;

      addNotification({
        type: 'info',
        text: translate('quickorder.import.started'),
      });

      // Parse the file text (CSV)
      csvParser(
        fileText,
        {
          delimiter: ';',
          columns: ['articleNumber', 'quantity'],
        },
        (err, records) => {
          if (
            records &&
            records[0] &&
            records[0].articleNumber == 'articleNumber' &&
            records[0].quantity == 'quantity'
          )
            records.splice(0, 1);

          if (err || records.length == 0) {
            return;
          }

          // Get the variant data based on the article number from the CSV file
          post(
            '/api/quickorder/many',
            records.map((row) => row.articleNumber)
          )
            .then((res) => res.json())
            .then((rows) => {
              if (rows.filter((r) => r.articleNumber).length == 0) {
                addNotification({
                  type: 'warning',
                  text: translate('quickorder.import.no-rows'),
                });
                return;
              }

              // If the imported row count were smaller than the default number of rows, add empty rows until reached "defaultNumRows"
              if (defaultNumRows > rows.length) {
                var rowsLeft = defaultNumRows - rows.length;
                for (var rowIdx = 0; rowIdx < rowsLeft; rowIdx++) {
                  rows.push(getEmptyRow());
                }
              }

              // Set correct quantity from the CSV file
              for (var record of records) {
                var row = rows.find(
                  (r) => r.articleNumber == record.articleNumber
                );
                row.quantity =
                  typeof record.quantity != 'undefined' ? record.quantity : 1;

                var currencySymbol =
                  row.currency?.symbol ?? row.totalPrice.match(/(\d+)/);
                var formattedRowPrice = formatPrice(
                  currencySymbol,
                  getCalculatedTotalPrice(row, row.quantity)
                );
                row.formattedTotalPrice = formattedRowPrice;
              }
              addRowToEnd(rows);
              setRows(rows);
              addNotification({
                type: 'success',
                text: translate('quickorder.import.success'),
              });
            })
            .catch((err) => {
              addNotification({
                type: 'error',
                text: `${translate('quickorder.import.error')} : ${err}`,
              });
            });
        }
      );
    };

    // Clear selected file from input
    importFileInputRef.current.value = null;
  };

  return (
    <>
      <div className="quick-order__import-export-wrapper">
        <button
          className="btn btn--secondary btn--small"
          onClick={() => importCSV()}
        >
          {translate('quickorder.import')}
        </button>
        <input
          type="file"
          accept=".txt,.csv"
          onChange={(e) => parseCSV(e.target.files)}
          hidden
          ref={importFileInputRef}
        />
      </div>
      {notification.text && notification.type && (
        <Notification type={notification.type} text={notification.text} />
      )}
    </>
  );
};

export default QuickOrderHeader;
